export const disclaimerUat = {
  link: 'layout.disclaimer.link',
}
